export const CONFIG_PANEL_SCROLL_CONTAINER_ID =
  "create-with-ia-config-panel-scroll";
export const REFERENCE_IMAGES_SECTION_ID =
  "create-with-ia-reference-images-section";
export const REFERENCE_AD_SECTION_ID = "create-with-ia-reference-ad-section";
export const SERVICE_VIDEO_LOGO_SECTION_ID =
  "create-with-ia-service-video-logo-section";

const TOP_OFFSET = 16;
const ACCORDION_EXPAND_DELAY_MS = 300;

const scrollToSection = ({ sectionId }) => {
  const section = document.getElementById(sectionId);
  if (!section) return false;

  const scrollContainer = document.getElementById(
    CONFIG_PANEL_SCROLL_CONTAINER_ID
  );

  if (!scrollContainer) {
    section.scrollIntoView({ behavior: "smooth", block: "start" });
    return true;
  }

  const containerRect = scrollContainer.getBoundingClientRect();
  const sectionRect = section.getBoundingClientRect();
  const nextScrollTop =
    scrollContainer.scrollTop +
    (sectionRect.top - containerRect.top) -
    TOP_OFFSET;

  scrollContainer.scrollTo({
    top: Math.max(nextScrollTop, 0),
    behavior: "smooth",
  });

  return true;
};

export const scrollToConfigPanelSection = ({ sectionId }) => {
  requestAnimationFrame(() => {
    if (scrollToSection({ sectionId })) return;

    setTimeout(() => {
      scrollToSection({ sectionId });
    }, ACCORDION_EXPAND_DELAY_MS);
  });
};
